import { render, staticRenderFns } from "./ControversyDetailModal.vue?vue&type=template&id=3f8f1d94&scoped=true&"
import script from "./ControversyDetailModal.vue?vue&type=script&lang=js&"
export * from "./ControversyDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ControversyDetailModal.vue?vue&type=style&index=0&id=3f8f1d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8f1d94",
  null
  
)

export default component.exports